export default import.meta.ROLLDOWN_FILE_URL_1PPZopJAy9kH5xWN2$lQJg